import React, { useMemo, useState } from "react";

import "bootstrap-icons/font/bootstrap-icons.css";

import { Link, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";



import SidebarNavSections from "./SidebarNavSections";

import { MobilePlanPill } from "./SidebarPlanSummary";

import UserMenu from "./UserMenu";

import CreateContentButton from "./CreateContentButton";

import LegalFooterLinks from "./shared/LegalFooterLinks";

import { useSidebarNavSections } from "../hooks/useSidebarNavSections";

import { trackCtaClicked } from "../analytics/analytics";
import { ANALYTICS_CTAS, ANALYTICS_ENTRY_POINTS } from "../analytics/analytics.constants";
import logo from "../assets/echovibe.png";



/**

 * Mobile-only: thin top bar (menu) + slide-out drawer.

 * Desktop chrome lives in Sidebar (logo, user menu).

 */

const Navbar = () => {

    const location = useLocation();
    const navSections = useSidebarNavSections();

    const { data: planData, loading: planLoading, loaded: planLoaded } = useSelector(

        (state) => state.plan

    );

    const [mobileOpen, setMobileOpen] = useState(false);



    const isNavActive = useMemo(

        () => (path) => path === location.pathname,

        [location.pathname]

    );



    const closeDrawer = () => setMobileOpen(false);

    const handleLogoClick = () => {
        trackCtaClicked(ANALYTICS_CTAS.NAV_LOGO);
        closeDrawer();
    };

    const handleOpenMenu = () => {
        trackCtaClicked(ANALYTICS_CTAS.NAV_MENU);
        setMobileOpen(true);
    };

    return (

        <>

            <nav

                className="fixed left-0 right-0 top-0 z-50 flex h-14 items-center justify-between gap-2 border-b border-slate-200/60 bg-white/90 px-3 backdrop-blur-md md:hidden"

                aria-label="Mobile navigation"

            >

                <Link to="/" className="flex min-w-0 shrink items-center" title="Home" onClick={() => trackCtaClicked(ANALYTICS_CTAS.NAV_LOGO)}>

                    <img

                        src={logo}

                        alt="EzePulse"

                        className="h-7 w-auto max-w-[110px] object-contain object-left"

                    />

                </Link>



                <div className="flex min-w-0 shrink-0 items-center gap-2">

                    <MobilePlanPill

                        planData={planData}

                        planLoading={planLoading}

                        planLoaded={planLoaded}

                    />

                    <CreateContentButton entryPoint={ANALYTICS_ENTRY_POINTS.SIDEBAR} />

                    <button

                        type="button"

                        className="flex h-10 w-10 shrink-0 items-center justify-center border-0 bg-transparent p-0 text-slate-900 shadow-none transition active:scale-95"

                        aria-label="Open menu"

                        aria-expanded={mobileOpen}

                        onClick={handleOpenMenu}

                    >

                        <i className="bi bi-list text-xl leading-none" aria-hidden />

                    </button>

                </div>

            </nav>



            <div

                className={`fixed inset-0 z-[60] md:hidden transition-opacity duration-300 ${

                    mobileOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"

                }`}

            >

                <button

                    className="absolute inset-0 bg-black/30"

                    onClick={closeDrawer}

                    type="button"

                    aria-label="Close menu overlay"

                />



                <div

                    className={`absolute bottom-0 left-0 top-0 flex w-[248px] max-w-[85vw] flex-col overflow-hidden border-r border-slate-300 bg-white/95 px-3 pb-4 pt-3 shadow-2xl backdrop-blur-xl transition-transform duration-300 app-chrome-surface ${

                        mobileOpen ? "translate-x-0" : "-translate-x-full"

                    }`}

                >

                    <div className="mb-3 shrink-0 border-b border-slate-200/50 pb-3">

                        <div className="flex items-center justify-between gap-2">

                            <Link

                                to="/"

                                className="flex min-w-0 flex-1 items-center gap-2"

                                title="Home"

                                onClick={handleLogoClick}

                            >

                                <img

                                    src={logo}

                                    alt="EzePulse"

                                    className="h-8 w-auto max-w-[120px] object-contain object-left"

                                />

                            </Link>

                            <UserMenu onLoggedOut={closeDrawer} />

                            <button

                                type="button"

                                className="shrink-0 rounded-md p-2 text-slate-600 transition hover:bg-slate-200/40"

                                aria-label="Close menu"

                                onClick={closeDrawer}

                            >

                                <i className="bi bi-x-lg" aria-hidden />

                            </button>

                        </div>

                    </div>



                    <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain no-scrollbar">

                        <SidebarNavSections

                            sections={navSections}

                            isActive={isNavActive}

                            onItemClick={closeDrawer}

                            className="pb-2"

                        />

                    </div>



                    <LegalFooterLinks
                        className="mb-0 mt-2 shrink-0 whitespace-nowrap border-t border-slate-200/50 px-1 pt-3 text-center text-[10px] leading-none text-slate-500"
                        onLinkClick={closeDrawer}
                    />

                </div>

            </div>

        </>

    );

};



export default Navbar;

